import React from 'react';
import EcoClub2Class2025 from '../views/EcoClub2Class2025/EcoClub2Class2025';

const DesktopAppPage = () => {
  return <EcoClub2Class2025 />;
};

export default DesktopAppPage;
